import React from 'react'
import PaymentReconciliation from '../../features/PaymentReconciliation/PaymentReconciliation'

const PaymentReconciliationRecord = () => {
  return (
    <div>
      <PaymentReconciliation />
    </div>
  )
}

export default PaymentReconciliationRecord
